import type { ReactNode } from 'react'
import { Children, createContext, useContext } from 'react'

export type Variant = 'medium' | 'small'

/**
 * Context
 */

type ListContext = {
  index: number
  variant: Variant
}

const Context = createContext<ListContext | null>(null)

/**
 * Provider
 */

type Props = {
  children: ReactNode
  variant: Variant
}

export const ListProvider = ({ children, variant }: Props) => (
  <>
    {Children.map(children, (child, index) => (
      <Context.Provider value={{ index, variant }}>{child}</Context.Provider>
    ))}
  </>
)

/**
 * Hook
 */

export const useList = () => {
  const context = useContext(Context)

  if (!context) {
    throw new Error('useList must be used within a ListProvider')
  }

  return context
}
